import React from 'react'
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom"
import { Contacto } from '../Componentes/Contacto'
import { Curriculum } from '../Componentes/Curriculum'
import { Inicio } from '../Componentes/Inicio'
import { Footer } from '../Componentes/layout/Footer'
import { HeaderNav } from '../Componentes/layout/HeaderNav'
import { Portafolio } from '../Componentes/Tecnologias'
import { Servicios } from '../Componentes/Servicios'
import Cursos from '../Componentes/Cursos'
import Emailenviado from '../Componentes/Emailenviado'

export const MisRutas = () => {
    return (
        <BrowserRouter>
            {/*HERADER Y NAVEGACION */}
            <HeaderNav />

            {/*CONTENIDO CENTRAL*/}
            <section className='content'>
                <Routes>
                    <Route path='/' element={<Navigate to="/inicio" />} />
                    <Route path='/inicio' element={<Inicio />} />
                    <Route path='/tecnologias' element={<Portafolio />} />
                    <Route path='/servicios' element={<Servicios />} />
                    <Route path='/curriculum' element={<Curriculum />} />
                    <Route path='/pdf' element={<Cursos />} />
                    <Route path='/contacto' element={<Contacto />} />
                    <Route path='/emailenviado' element={<Emailenviado />} />
                </Routes>
            </section>


            {/*FOOTER*/}
            <Footer />
        </BrowserRouter>
    )
}
